// extracted by mini-css-extract-plugin
export var downArrow = "_8o-0";
export var infoTooltipIcon = "_8o-3";
export var label = "_8o-1";
export var optionCard = "_8o-4";
export var upArrow = "_8o-2";